<template>
    <header>
        <div ref="header"
         class="header-inner">
            <router-link class="logo"
             to="/">
                <svg width="72"
                 height="31"
                 viewBox="0 0 72 31"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                    <g clip-path="url(#clip0_4_3)">
                        <path fill-rule="evenodd"
                         clip-rule="evenodd"
                         d="M46.3846 31H36H25.6151H15.2306C13.1364 31 11.1374 30.5642 9.31679 29.7769C7.49644 28.9896 5.85443 27.8515 4.47394 26.447C3.09377 25.0421 1.97513 23.371 1.20184 21.5182C0.428242 19.6653 0 17.6313 0 15.4998C0 13.3687 0.428242 11.3344 1.20184 9.48151C1.97513 7.62898 3.09377 5.95762 4.47394 4.55304C5.85443 3.14847 7.49644 2.01005 9.31679 1.22277C11.1374 0.435814 13.1364 0 15.2306 0H25.6151H36H46.3846H56.7691C58.8632 0 60.8626 0.435814 62.6829 1.22277C64.5036 2.01005 66.1456 3.14847 67.5261 4.55304C68.9062 5.95762 70.0249 7.62898 70.7982 9.48151C71.5714 11.3344 72 13.3687 72 15.4998C72 17.6313 71.5714 19.6653 70.7982 21.5182C70.0249 23.371 68.9062 25.0421 67.5261 26.447C66.1456 27.8515 64.5036 28.9896 62.6829 29.7769C60.8626 30.5642 58.8632 31 56.7691 31H46.3846Z"
                         :fill="logoColor1" />
                        <path fill-rule="evenodd"
                         clip-rule="evenodd"
                         d="M55.594 11.9776H49.2985C49.0316 11.9776 48.8156 12.1965 48.8156 12.4673C48.8156 12.738 49.0316 12.9573 49.2985 12.9573H51.9632V18.5213C51.9632 18.7917 52.1796 19.0109 52.4461 19.0109C52.7126 19.0109 52.9287 18.7917 52.9287 18.5213V12.9573H55.594C55.8606 12.9573 56.0769 12.738 56.0769 12.4673C56.0769 12.1965 55.8606 11.9776 55.594 11.9776ZM46.36 19.0109C46.6262 19.0109 46.8426 18.7917 46.8426 18.5213V12.4673C46.8426 12.1968 46.6262 11.9776 46.36 11.9776C46.0934 11.9776 45.8771 12.1968 45.8771 12.4673V18.5213C45.8771 18.7917 46.0934 19.0109 46.36 19.0109ZM43.2286 15.0143H37.748V12.9573H43.2318C43.4983 12.9573 43.7147 12.738 43.7147 12.4673C43.7147 12.1968 43.4983 11.9773 43.2318 11.9773H37.2658C36.9992 11.9773 36.7829 12.1968 36.7829 12.4673V15.4725C36.7819 15.4833 36.7797 15.4932 36.7797 15.504C36.7797 15.5148 36.7819 15.5247 36.7829 15.5355V18.5327C36.7829 18.8032 36.9992 19.0227 37.2658 19.0227C37.532 19.0227 37.748 18.8032 37.748 18.5327V15.994H43.2286C43.4952 15.994 43.7112 15.7747 43.7112 15.504C43.7112 15.2332 43.4952 15.0143 43.2286 15.0143ZM22.372 11.9874H16.406C16.1391 11.9874 15.9231 12.2067 15.9231 12.4771C15.9231 12.7476 16.1391 12.9671 16.406 12.9671H21.8891V15.0143H16.406C16.1391 15.0143 15.9231 15.2332 15.9231 15.504C15.9231 15.7747 16.1391 15.994 16.406 15.994H21.8891V18.0411H16.406C16.1391 18.0411 15.9231 18.2607 15.9231 18.5311C15.9231 18.8016 16.1391 19.0208 16.406 19.0208H22.372C22.6386 19.0208 22.8549 18.8016 22.8549 18.5311V12.4771C22.8549 12.2067 22.6386 11.9874 22.372 11.9874ZM31.5098 19.0208H25.5438C25.2773 19.0208 25.0609 18.8016 25.0609 18.5311C25.0609 18.2607 25.2773 18.0411 25.5438 18.0411H31.0272V15.994H25.5438C25.2773 15.994 25.0609 15.7747 25.0609 15.504V12.4771C25.0609 12.2067 25.2773 11.9874 25.5438 11.9874H31.5098C31.7767 11.9874 31.9927 12.2067 31.9927 12.4771C31.9927 12.7476 31.7767 12.9671 31.5098 12.9671H26.0264V15.0143H31.5098C31.7767 15.0143 31.9927 15.2335 31.9927 15.504V18.5311C31.9927 18.8016 31.7767 19.0208 31.5098 19.0208Z"
                         :fill="logoColor2" />
                    </g>
                    <defs>
                        <clipPath id="clip0_4_3">
                            <rect width="72"
                             height="31"
                             :fill="logoColor2" />
                        </clipPath>
                    </defs>
                </svg>
            </router-link>

            <div class="header-right-group">
                <div class="lang-open"
                 @mouseover="langMenuOpen = true"
                 @mouseleave="langMenuOpen = false">
                    <span>{{ this.$i18n.locale }}</span>

                    <transition name="bounce">
                        <div class="lang-wrap"
                         v-if="langMenuOpen">

                            <LanguageSelect />
                        </div>
                    </transition>
                </div>
                <button class="menu-toggle"
                 @:click="openMenu">
                    <img v-if="menuOpen"
                     :src="cross"
                     alt="cross">
                    <img v-else
                     :src="menu"
                     alt="menu">
                </button>
            </div>

        </div>
        <transition name="bounce"
         mode="out-in">
            <div v-if="menuOpen"
             class="menu-inner">
                <nav>
                    <ul>
                        <li v-if="(this.$route.path != '/')">
                            <router-link to="/">
                                <HeaderItem @click="openMenu"
                                 :heading="$t('header.menu.home.name')"
                                 photo="https://35fit.s3.eu-north-1.amazonaws.com/gallery/gallery_1.jpg"
                                 :text="$t('header.menu.home.desc')" />
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/training">
                                <HeaderItem @click="openMenu"
                                 :heading="$t('header.menu.training.name')"
                                 photo="https://35fit.s3.eu-north-1.amazonaws.com/gallery/gallery_2.jpg"
                                 :text="$t('header.menu.training.desc')" />
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/pricing">
                                <HeaderItem @click="openMenu"
                                 :heading="$t('header.menu.pricing.name')"
                                 photo="/menu/media5.webp"
                                 :text="$t('header.menu.pricing.desc')" />
                            </router-link>
                        </li>
                        <li>
                            <router-link to="/faq">
                                <HeaderItem @click="openMenu"
                                 :heading="$t('header.menu.faq.name')"
                                 photo="/menu/media1.webp"
                                 :text="$t('header.menu.faq.desc')" />
                            </router-link>
                        </li>
                    </ul>
                    <div class="bottom-buttons">
                        <router-link @click="scrollStop"
                         to="/login">
                            <div class="account">
                                <img :src="account"
                                 :alt="$t('header.account')">
                                <span>{{ accountButtonText }}</span>
                            </div>
                        </router-link>

                        <router-link @click="scrollStop"
                         v-if="show"
                         to="/register">
                            <div class="account">
                                <img src="/svg/register.svg"
                                 :alt="$t('register')">
                                <span>{{ $t('register') }}</span>
                            </div>
                        </router-link>
                    </div>
                </nav>

            </div>
        </transition>


    </header>
</template>

<script>
import HeaderItem from '@/components/layout/HeaderItem.vue'
import home from '@/assets/svg/home.svg'
import menuWhite from '@/assets/svg/menu.svg'
import menuBlack from '@/assets/svg/menu-black.svg'
import crossBlack from '@/assets/svg/cross-black.svg'
import crossWhite from '@/assets/svg/cross-white.svg'
import euro from '@/assets/svg/euro.svg'
import faq from '@/assets/svg/faq.svg'
import training from '@/assets/svg/training.svg'
import calendar from '@/assets/svg/calendar.svg'
import account from '@/assets/svg/account.svg'
import lang from '@/assets/svg/lang.svg'
import LanguageSelect from '@/components/selectors/LanguageSelect.vue'

export default {
    displayName: 'HeaderComp',
    components: {
        HeaderItem,
        LanguageSelect
    },
    data() {
        return {
            logoColor1: '#000044',
            logoColor2: 'white',
            home,
            menuBlack,
            menuWhite,
            menu: menuBlack,
            crossWhite,
            crossBlack,
            cross: crossBlack,
            menuOpen: false,
            euro: euro,
            faq: faq,
            training: training,
            calendar: calendar,
            account: account,
            lang: lang,
            langMenuOpen: false,
            accountButtonText: this.$t('header.login'),
            lastscrollstop: 0,
            show: localStorage.getItem('token') ? false : true,
        };
    },
    watch: {
        $route() {
            this.showHeader();
            // this.changeUIColor();
        },

    },
    mounted() {

        if (localStorage.getItem('token')) {
            this.accountButtonText = this.$t('header.account')
        } else {
            this.accountButtonText = this.$t('header.login')
        }
        window.addEventListener('scroll', () => {
            this.hasScrolled();
            // this.changeUIColor();
        });
        // this.changeUIColor();
    },
    unmounted() {
        window.removeEventListener('scroll', () => {
            this.hasScrolled();
            // this.changeUIColor();
        });
    },
    methods: {
        showHeader() {
            const header = this.$refs.header;
            header.classList.remove('hide-header');
        },
        changeUIColor() {
            const st = window.scrollY || document.documentElement.scrollTop;
            const langOpen = document.querySelector('.lang-open span');
            if (this.$route.path === '/' && st < 100) {
                this.menu = this.menuWhite;
                this.cross = this.crossWhite;
                langOpen.style.color = 'white';
                this.logoColor1 = 'white';
                this.logoColor2 = '#000044';
            } else {
                this.menu = this.menuBlack;
                this.cross = this.crossBlack;
                langOpen.style.color = 'black';
                this.logoColor1 = '#000044';
                this.logoColor2 = 'white';
            }
        },
        hasScrolled() {
            const header = this.$refs.header;
            const st = window.scrollY || document.documentElement.scrollTop;
            if (header) {
                if (st > 100) {
                    if (Math.abs(this.lastscrollstop - st) <= 5) {
                        return;
                    }

                    header.classList.add('blur');

                    if (st > this.lastscrollstop) {
                        header.classList.add('hide-header');
                        this.langMenuOpen = false;
                    } else {
                        header.classList.remove('hide-header');
                    }
                    this.lastscrollstop = st;
                } else {
                    header.classList.remove('blur');
                }
            }

        },
        openMenu() {
            const body = document.querySelector('body');
            body.classList.toggle('menu-open');
            if (this.menuOpen) {
                this.menuOpen = false;
            } else {
                this.menuOpen = true;
            }
        },
        scrollStop() {
            const body = document.querySelector('body');
            body.classList.remove('menu-open');
        }
    },
}


</script>

<style scoped>
.no-scroll {
    overflow-y: hidden !important;
}

.hide-header {
    top: -80px !important;
}

.lang-open {
    position: relative;
}

.lang-open span {
    font-weight: 600;
    font-size: 16px;
    cursor: default;
    user-select: none;
    text-transform: uppercase;
}

.lang-wrap {
    position: absolute;
    right: -30px;
    z-index: 100;
    padding-top: 10px;
}

.header-right-group {
    display: flex;
    align-items: center;
    gap: 10px;
}

.locales-btn-icon {
    width: 1.3rem;
    height: 1.3rem;
    fill: black;

}

.header-inner {
    display: flex;
    justify-content: space-between;
    padding: var(--header-padding);
    align-items: center;
    height: var(--header-height);
    position: fixed;
    transition: all .4s cubic-bezier(0.54, -0.03, 0, 0.96);
    /* background: linear-gradient(0deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0.35) 100%); */
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;
    width: 100%;

}

.white-background {
    background-color: white !important;
}

.menu-toggle {
    padding: 25px 0px 25px 15px;
    width: 35px;
}

.bottom-buttons {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 20px 0;
    animation: fade 0.5s ease-in-out;
}

@keyframes fade {
    0% {
        opacity: 0;
        transform: translateY(5%);
    }

    100% {
        opacity: 1;
        transform: translateY(0);
    }
}

.blur {
    background-color: rgba(255, 255, 255, 0.45);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
}

.account,
.lang {
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 10px;
    color: black;
    font: var(--font);
    font-size: 14px;
    font-weight: 600;
    padding: 5px 10px;
}

.logo {
    display: flex;
    align-items: center;
}

.logo svg {
    transition: fill 0.3s ease-in-out;
}

.menu-inner {
    position: fixed;
    top: var(--header-height);
    right: 20px;
    padding-top: 10px;
    width: 400px;
    border-radius: var(--br);
    background-color: #fff;
    z-index: 99;
    height: 80%;
    max-height: 563px;
    overflow-y: scroll;
    transition: all 0.8s ease-in-out;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
}

nav {
    z-index: 100;
}

ul {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    list-style: none;
}

ul li {
    width: 100%;
}

@media screen and (max-width: 880px) {



    .menu-inner {
        width: 100%;
        height: calc(100% - var(--header-height));
        right: 0;
        max-height: unset;
        border-bottom-left-radius: 0;
        border-bottom-right-radius: 0;
    }

}
</style>
